export default function Numpy_DataTypes() {
  return <div>Numpy_DataTypes Component</div>;
}
